<template>
  <div class="flex w-full items-center gap-2">
    <SButton
      type="button"
      variant="outline"
      size="sm"
      class="flex-1 cursor-pointer disabled:cursor-not-allowed"
      data-cy="select-order-button"
      @click="onClick"
    >
      {{ $t("button.edit-order") }}
    </SButton>

    <SButton
      type="button"
      v-if="isCheckInAvailable"
      size="sm"
      class="flex-1 cursor-pointer disabled:cursor-not-allowed"
      data-cy="order-check-in-button"
      @click="onCheckIn"
    >
      <i
        class="s-icon s-icon--check size-4"
        style="--s-icon-size: 14px"
        aria-hidden="true"
      />
      {{ $t("check-in.title") }}
    </SButton>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { SButton } from "@smeetz/ui-core";

import { openOrderFromTable } from "@/utils/vue-helpers/orders";
import { openModalWithProps } from "@/utils/vue-helpers/modal";
import { isCheckInEnabled } from "@/utils/helpers/feature-flags";
import { ModalStatus } from "@/constants/modal";
import type { IParsedOrder } from "@/interfaces/store/IOrder";

import "@smeetz/ui-icons/check/style.css";

const props = defineProps<{ row: Record<string, unknown> }>();

const isCheckInAvailable = computed(() => isCheckInEnabled());

/**
 * Hand off to the shared order-click flow.
 *
 * @returns {boolean} Sentinel.
 */
function onClick(): boolean {
  openOrderFromTable(props.row as unknown as IParsedOrder);

  return true;
}

/**
 * Open the check-in page for this order. The page reads the order by its
 * reference, so it opens without loading the order in the basket.
 *
 * @returns {boolean} Sentinel.
 */
function onCheckIn(): boolean {
  openModalWithProps(ModalStatus.CheckIn, {
    reference: String(props.row.reference || ""),
    title: String(props.row.reference || ""),
  });

  return true;
}
</script>
